<div class="flexContainer" style="padding: 2%;">
  <!-- <div class="title">
    <h1>Setup Induction and Sections</h1>
  </div> -->

  <div *ngIf="this.categories.length > 0">


    <mat-list role="list" *ngFor="let cat of this.categories;index as catIndex">

      <mat-list-item role="listitem">
        <div class="listItemContainer">


          <div class="ListTitleContainer">
            <span class="CatTitle">{{cat.Title}} </span>
            <button mat-button (click)="EditCategory(cat)">
              <mat-icon click>create</mat-icon>
            </button>

          </div>
        </div>

      </mat-list-item>
      

      <mat-list role="list" *ngFor="let qus of cat.questions; let i = index">

        <mat-list-item  role="listitem">
          <div class="SectionlistItemContainer">
            
            <div class="ListTitleContainer">
              <button mat-button (click)="ChangeActive(qus)" mat-icon->
                <mat-icon *ngIf="qus.Active" style="color:green">done</mat-icon>
                <mat-icon *ngIf="!qus.Active" style="color:red">close</mat-icon>
              </button>
              <span class="SectionTitle">{{qus.Title}} </span>
              <button mat-button (click)="EditSection(qus)" mat-icon->
                <mat-icon>create</mat-icon>
              </button>
            </div>

            <div>
              <button mat-button class="crt" [disabled]="i+1 == this.questions.length"
                (click)="SectionDown(qus.InductionType,qus.Order)">
                <mat-icon>keyboard_arrow_down</mat-icon>
              </button>
              <button mat-button class="crt" [disabled]="i == 0" (click)="SectionUp(qus.InductionType,qus.Order)">
                <mat-icon>keyboard_arrow_up</mat-icon>
              </button>
            </div>

          </div>
        </mat-list-item>

        <mat-divider></mat-divider>
      </mat-list>

      <div class="addSectionButton">
        <button (click)="openAddSectionDialog(cat)" mat-raised-button color="lightgray">
          <i class="material-icons alert__icon">add</i>
         {{" Add Section" | translate | async}}
        </button>
      </div>


    </mat-list>


    <!-- <div class="row">
    <div class="marg">
      <div class="column">

        <mat-label style="margin-right: 8px; text-decoration: underline;font-size:x-large;font-style: bold;">Safety
          Inductions</mat-label>

      </div>
    </div>
  </div>

  <table style="width:75%; margin-left: 5cm;">

    <tr>
      <td>First Section</td>

      <button class="crt" mat-icon-button>
        <mat-icon>create</mat-icon>
      </button>
      <button style="margin-left: 1cm;" class="crt" mat-icon-button>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </tr>
    <tr>
      <td>Second Section</td>

      <button class="crt" mat-icon-button>
        <mat-icon>create</mat-icon>
      </button>
      <button class="crt" mat-icon-button>
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <button class="crt" mat-icon-button>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </tr>
  </table>

  <div class="row">
    <div class="marg">
      <div class="column">
        <button class="addworkarea" mat-raised-button>
          <mat-icon>add</mat-icon>Add Section
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="marg">
      <div class="column">

        <mat-label style="margin-right: 8px; text-decoration: underline;font-size:x-large;font-style: bold;">On Boarding
        </mat-label>

      </div>
    </div>
  </div>

  <table style="width:75%; margin-left: 5cm;">

    <tr>
      <td>Arriving</td>

      <button class="crt" mat-icon-button>
        <mat-icon>create</mat-icon>
      </button>
      <button style="margin-left: 1cm;" class="crt" mat-icon-button>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </tr>
    <tr>
      <td>Starting Out</td>

      <button class="crt" mat-icon-button>
        <mat-icon>create</mat-icon>
      </button>
      <button class="crt" mat-icon-button>
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <button class="crt" mat-icon-button>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>

    </tr>

  </table>

  <div class="row">
    <div class="marg">
      <div class="column">
        <button class="addworkarea" mat-raised-button>
          <mat-icon>add</mat-icon>Add Section
        </button>
      </div>
    </div>
  </div> -->



  </div>

  <!-- Add Induction Types -->
  <div class="flexContainer InductionButtonContainer">
    <button mat-raised-button color="lightgray" (click)="openAddInductionTypesDialog()" class="addCatBtn">

      <i class="material-icons alert__icon">add</i>
      {{"Add Induction Type" | translate | async}}

    </button>
  </div>


</div>